var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 5.83333C13.3337 6.71739 12.9825 7.56523 12.3573 8.19036C11.7322 8.81548 10.8844 9.16667 10.0003 9.16667C9.11627 9.16667 8.26842 8.81548 7.6433 8.19036C7.01818 7.56523 6.66699 6.71739 6.66699 5.83333C6.66699 4.94928 7.01818 4.10143 7.6433 3.47631C8.26842 2.85119 9.11627 2.5 10.0003 2.5C10.8844 2.5 11.7322 2.85119 12.3573 3.47631C12.9825 4.10143 13.3337 4.94928 13.3337 5.83333ZM10.0003 11.6667C8.45323 11.6667 6.9695 12.2812 5.87554 13.3752C4.78157 14.4692 4.16699 15.9529 4.16699 17.5H15.8337C15.8337 15.9529 15.2191 14.4692 14.1251 13.3752C13.0312 12.2812 11.5474 11.6667 10.0003 11.6667Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconProfile);
export default __webpack_public_path__ + "static/media/common_icon_profile.7f655ecb73b4bb392d4e1cde40396418.svg";
export { ForwardRef as ReactComponent };